"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.receiptData = void 0;
exports.receiptData = `query GetReceiptData($limit: Int, $receiptType: String!, $after: String) {
  objects(first: $limit, after: $after, filter: { type: $receiptType }) {
    nodes {
      asMoveObject {
        status
        contents {
          json
        }
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
`;
//# sourceMappingURL=receiptData.js.map